import { IndicatorItem } from "@/modules/PhishTitan/types/IncidentSummary";
import {
  IndicatorTypeSupported,
  ThreatCoachIndicator,
  isIndicatorSupportedType,
} from "../types/threatCoach";

const mapIndicatorTypeToColorClass = (indicatorType: IndicatorTypeSupported) =>
  ({
    "Generic Greeting": "tw-bg-generic-greeting",
    "Urgent/Threatening Language": "tw-bg-urgent-threatening-language",
    "Spelling/Grammar Errors": "tw-bg-spelling-grammar-errors",
    "Requests for PII": "tw-bg-request-for-pii",
    "Unexpected Reward": "tw-bg-unexpected-reward",
    "Unrealistic Offer": "tw-bg-unrealistic-offer",
    "Brand Impersonation": "tw-bg-brand-impersonation",
    "Request for Financial Assistance": "tw-bg-request-financial-assistance",
  })[indicatorType];

const mapIndicatorTypeToTag = (indicatorType: IndicatorTypeSupported) =>
  ({
    "Generic Greeting": "GENERIC GREETING",
    "Urgent/Threatening Language": "URGENCY",
    "Spelling/Grammar Errors": "GRAMMAR",
    "Requests for PII": "PII REQUEST",
    "Unexpected Reward": "REWARD",
    "Unrealistic Offer": "OFFER",
    "Brand Impersonation": "IMPERSONATION",
    "Request for Financial Assistance": "FINANCIAL",
  })[indicatorType];

const mapIndicatorTypeToStaticDescription = (
  indicatorType: IndicatorTypeSupported,
) =>
  ({
    "Generic Greeting": "generic-greeting-description",
    "Urgent/Threatening Language": "threatening-language",
    "Spelling/Grammar Errors": "spelling-grammar-description",
    "Requests for PII": "request-for-pii-description",
    "Unexpected Reward": "unexpected-reward-description",
    "Unrealistic Offer": "unrealistic-offers-description",
    "Brand Impersonation": "brand-impersonation-description",
    "Request for Financial Assistance":
      "request-for-financial-assistance-description",
  })[indicatorType];

const mapIndicatorTypeToTitle = (indicatorType: IndicatorTypeSupported) =>
  ({
    "Generic Greeting": "generic-greeting-indicator",
    "Urgent/Threatening Language": "urgent-language",
    "Spelling/Grammar Errors": "spelling-grammar-indicator",
    "Requests for PII": "request-for-pii-indicator",
    "Unexpected Reward": "unexpected-reward-indicator",
    "Unrealistic Offer": "unrealistic-offers-indicator",
    "Brand Impersonation": "brand-impersonation",
    "Request for Financial Assistance":
      "request-for-financial-assistance-indicator",
  })[indicatorType];

const transformIndicatorToThreatCoachIndicator = (
  indicator: IndicatorItem,
): ThreatCoachIndicator | undefined => {
  const indicatorType = indicator.indicator;

  if (isIndicatorSupportedType(indicatorType) && indicator.keywords.length) {
    return {
      title: mapIndicatorTypeToTitle(indicatorType),
      type: indicatorType,
      keywords: indicator.keywords,
      staticDescription: mapIndicatorTypeToStaticDescription(indicatorType),
      tag: mapIndicatorTypeToTag(indicatorType),
      colorClass: mapIndicatorTypeToColorClass(indicatorType),
    };
  } else {
    return;
  }
};

export const transformIndicatorsToThreatCoachIndicators = (
  indicators: IndicatorItem[],
): ThreatCoachIndicator[] =>
  indicators.reduce(
    (transformedIndicators: ThreatCoachIndicator[], indicator) => {
      const threatCoachIndicator =
        transformIndicatorToThreatCoachIndicator(indicator);
      return threatCoachIndicator
        ? [...transformedIndicators, threatCoachIndicator]
        : transformedIndicators;
    },
    [],
  );
